import Toast from "@components/primitives/toast/Toast";
import { appPath } from "@routes/app";
import { baseURL } from "@routes/api";
import axios, { AxiosResponse } from "axios";

const defaultTimeoutLength = 4000; // 4 seconds

const axiosInstance = axios.create({
  baseURL, // baseURL is defined in @routes/api
  headers: {
    Accept: "application/json",
    "Cache-Control": "no-cache",
  },
});

axiosInstance.interceptors.response.use(
  (response: AxiosResponse) => {
    return response;
  },
  (error: any) => {
    if (error.response) {
      const { status, data } = error.response;
      if (status === 440) {
        window.location.href = appPath.default;
        Toast("error", data);
      }
    }
    return error;
  }
);

export const executeGetRequest = (path: string, lang: string) => {
  const promise = axiosInstance.get(path, {
    timeout: defaultTimeoutLength,
    headers: {
      Language: lang,
    },
  });

  return [promise];
};

export const executePostRequest = (path: string, data: any, lang: string) => {
  const promise = axiosInstance.post(path, data, {
    timeout: defaultTimeoutLength,
    headers: {
      Language: lang,
    },
  });

  return [promise];
};

export const executePutRequest = (path: string, data: any, lang: string) => {
  const promise = axiosInstance.put(path, data, {
    timeout: defaultTimeoutLength,
    headers: {
      Language: lang,
    },
  });

  return [promise];
};

export const executeDeleteRequest = (path: string, lang: string) => {
  const promise = axiosInstance.delete(path, {
    timeout: defaultTimeoutLength,
    headers: {
      Language: lang,
    },
  });

  return [promise];
};
